module.exports = __webpack_public_path__ + "static/media/Logistic_Providers_Challenges_-_GBR_Network_-_29-05-2024_-_N-removebg-preview.1e0d7471.png";